import routeConst from './const.js';

/**
 * AFFILIATE ROUTES
 */

export default [
  {
    path: '/:lang?/affiliate',
    component: () => import('@/views/account-2023/Account.vue'),
    children: [
      {
        path: '',
        redirect: routeConst.DASHBOARD,
      },
      {
        path: 'report',
        redirect: 'report/referral',
      },
      {
        path: 'report/referral',
        name: 'affiliate-report-referral',
        component: () => import(/* webpackChunkName: "affiliate" */ '@/views/affiliate/Affiliate.vue'),
      },
      {
        path: 'connect-wise',
        name: 'affiliate-connect-wise',
        meta: { hideSidebar: true },
        component: () => import('@motionelements/core/src/components/payouts/wise/ConnectWise.vue'),
      },
      {
        path: 'join',
        name: 'affiliate-join',
        meta: { hideSidebar: true, hideFooter: true },
        component: () => import('@/views/affiliate/AffiliateAgreement.vue'),
      },
    ],
  },
];
